import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import {
  windowAttrs,
  getBoundingClientRect,
  componentIsInViewport } from '../../../utils/dom';
import { sendAnalyticsEvent } from '../../../utils/analytics';
import ResponsiveImg from '../../common/responsive_img';

const SCROLL_BUFFER_HEIGHT = 90;
const INNER_HEIGHT_PERCENTAGE = 0.2;

export default class ProductDetailsImage extends Component {
  state = { isLoaded: false };

  componentDidMount() {
    if (!this.props.isInCarousel) {
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.handleScrollGAEvent);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('scroll', this.handleScrollGAEvent);
  }

  handleScrollGAEvent = () => {
    const { displayOrder } = this.props;

    if (componentIsInViewport(this.imgContainer, window)) {
      sendAnalyticsEvent('Scroll', 'Scroll Depth', `Image ${displayOrder + 1}`);
      window.removeEventListener('scroll', this.handleScrollGAEvent);
    }
  };

  handleScroll = () => {
    const { top: imageTop, bottom: imageBottom } = getBoundingClientRect(this.imgContainer);
    const { innerHeight } = windowAttrs();
    const { addActiveClassToIcons, removeActiveClassFromIcons, displayOrder } = this.props;

    if (imageTop <= SCROLL_BUFFER_HEIGHT && imageBottom >= SCROLL_BUFFER_HEIGHT) {
      addActiveClassToIcons(displayOrder);
    } else if (imageBottom <= SCROLL_BUFFER_HEIGHT ||
      imageTop >= (INNER_HEIGHT_PERCENTAGE * innerHeight)) {
      removeActiveClassFromIcons(displayOrder);
    }
  };

  handleImgLoad = () => {
    this.setState({ isLoaded: true });

    if (this.props.isInCarousel) {
      // this helps mobile slider figure out width of each image after it loads so it can center it properly
      window.dispatchEvent(new Event('resize'));
    }
  };

  setImgContainerRef = (element) => {
    this.imgContainer = element;
  };

  render() {
    const { imageURL } = this.props;
    const className = classNames('pd-img-container', { loading: !this.state.isLoaded });
    const imageProps = {
      src: imageURL,
      onLoad: this.handleImgLoad
    };

    return (
      <div
        className={className}
        ref={this.setImgContainerRef}
      >
        <ResponsiveImg {...imageProps} />
      </div>
    );
  }
}

ProductDetailsImage.propTypes = {
  isInCarousel: PropTypes.bool,
  imageURL: PropTypes.string.isRequired,
  displayOrder: PropTypes.number.isRequired,
  addActiveClassToIcons: PropTypes.func,
  removeActiveClassFromIcons: PropTypes.func
};
